import React from 'react';
import '../styles/notre-histoire.css';
import { Helmet } from 'react-helmet-async';

export default function NotreHistoire() {
  return (
    <>
      <Helmet>
        <title>Notre Histoire | KAZA</title>
        <meta name="description" content="Découvrez l'histoire de KAZA, la passion derrière nos mélanges d'épices artisanaux, notre mission et nos valeurs pour une cuisine créative et authentique." />
        <meta property="og:title" content="Notre Histoire | KAZA" />
        <meta property="og:description" content="Découvrez l'histoire de KAZA, la passion derrière nos mélanges d'épices artisanaux, notre mission et nos valeurs pour une cuisine créative et authentique." />
        <meta property="og:image" content="/images/logo-kaza-texte.svg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://kaza-epices.com/notre-histoire" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Notre Histoire | KAZA" />
        <meta name="twitter:description" content="Découvrez l'histoire de KAZA, la passion derrière nos mélanges d'épices artisanaux, notre mission et nos valeurs pour une cuisine créative et authentique." />
        <meta name="twitter:image" content="/images/logo-kaza-texte.svg" />
      </Helmet>
      <div className="notre-histoire-page">
        <header className="nh-header">
          <img src="/images/notre-histoire-header.jpg" alt="Bandeau Notre histoire KAZA" className="nh-header-img" />
          <h1 className="nh-title">Notre histoire</h1>
        </header>
        <main className="nh-content">
          <section className="nh-section">
            <h2 className="nh-titre-noir">Voyager sans quitter sa cuisine.</h2>
            <p>
              Tout est parti d’un constat simple : on adore cuisiner, mais on se lasse vite. Toujours les mêmes assaisonnements. Les mêmes plats. Et cette impression frustrante qu’il manque quelque chose pour vraiment sublimer ce qu’on prépare.
            </p>
            <p>
              Alors on a commencé à chercher. À comprendre. À goûter.<br/>
              On s’est plongés dans l’univers des épices comme dans une bibliothèque vivante, faite de traditions, d’histoires, de senteurs et de gestes. On a lu, on a testé, on s’est plantés, on a recommencé.<br/>
              On a appris à doser, à équilibrer, à respecter chaque ingrédient. Et surtout : à écouter ce que chaque plat essayait de dire.
            </p>
            <div className="nh-separator">⸻</div>
          </section>
          <section className="nh-section nh-section-img-right">
            <div className="nh-text-block">
              <h2 className="nh-titre-noir">Créer les bons mélanges, ce n’est pas une mode. C’est une obsession.</h2>
              <p>
                On n’est pas chefs. On n’a pas grandi dans une ferme bio au Sri Lanka.<br/>
                Mais on a cette envie viscérale de comprendre ce qu’on mange, et de le faire bien. De composer des mélanges qui aient du sens. Qui surprennent, sans être compliqués. Qui réconfortent, sans tomber dans le déjà-vu.<br/>
                <span className="nh-citation">Chaque mélange KAZA est né de cette exigence : faire voyager sans complexité, et sans tricher.</span>
              </p>
              <p>
                Pas de poudre magique. Pas d’additifs inutiles.<br/>
                <b>Juste le bon équilibre, la bonne intensité, la bonne histoire.</b>
              </p>
            </div>
            <div className="nh-img-block">
              <img src="/images/notre-histoire-portrait.jpg" alt="Portrait équipe KAZA" className="nh-img-portrait" />
            </div>
          </section>
          <div className="nh-separator">⸻</div>
          <section className="nh-section">
            <h2 className="nh-titre-noir">Ce qu’on veut, c’est redonner envie de cuisiner.</h2>
            <p>
              Pas pour épater la galerie. Mais pour se reconnecter.<br/>
              À soi. Aux autres. À ce qu’on met dans notre assiette.
            </p>
            <p>
              <b>KAZA, c’est ça :</b><br/>
              Une marque d’épices pour les gens qui aiment faire à manger, pas juste réchauffer.<br/>
              Des mélanges qui racontent quelque chose.<br/>
              Et une volonté simple : remettre du goût, du plaisir et un peu d’ailleurs dans le quotidien.
            </p>
          </section>
          <div className="nh-separator">⸻</div>
          <section className="nh-section nh-section-center">
            <h2 className="nh-titre-noir">Bienvenue chez KAZA.<br/>Installe-toi. Sens. Goûte. Et laisse-toi embarquer.</h2>
          </section>
        </main>
      </div>
    </>
  );
} 